import PropTypes from "prop-types";

const ClearButton = ({ className, onClick, disabled, children }) => (
  <button
    data-auto-id="clear"
    className={className}
    onClick={onClick}
    disabled={disabled}
  >
    {children}
  </button>
);

ClearButton.propTypes = {
  className: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
  disabled: PropTypes.bool
};

export default ClearButton;
